import { render, staticRenderFns } from "./Paymethods.vue?vue&type=template&id=399ac6c4&"
import script from "./Paymethods.vue?vue&type=script&lang=js&"
export * from "./Paymethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports